<template>
  <div class="sdc">
    <div class="sdc-head">
      <div>
        <div class="sdc-title">Senders that cannot send</div>
        <p class="sdc-note">
          Every workspace's sender identities whose From address is not on a verified sending domain of that
          workspace (workspace {{ operatorTenant }} may also use the platform domain). They keep their rows, but
          outreach and test mail from them fails with "sender: from-domain is not a verified domain of this workspace".
        </p>
      </div>
      <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="loading" @click="load">Refresh</button>
    </div>
    <p v-if="rule.warn_active" class="sdc-warn">
      email.from_domain_rule is set to warn while the recipient allowlist is on: these senders are logged, not refused.
    </p>
    <p v-else-if="rule.warn_requested" class="sdc-note">
      email.from_domain_rule is set to warn, but the recipient allowlist is off, so the rule is enforced.
    </p>
    <div v-if="loading" class="text-muted small">Loading...</div>
    <div v-else-if="error" class="alert alert-danger py-1 px-2 small mb-0">{{ error }}</div>
    <p v-else-if="!rows.length" class="sdc-note">Every sender identity is on a verified sending domain of its workspace.</p>
    <table v-else class="table table-sm sdc-table">
      <thead>
        <tr><th>Workspace</th><th>Sender</th><th>From address</th><th>Why</th><th>Default</th><th>Active</th></tr>
      </thead>
      <tbody>
        <tr v-for="r in rows" :key="r.id">
          <td>{{ r.tenant_name || 'Workspace' }} <span class="text-muted">#{{ r.tenant_id }}</span></td>
          <td>{{ r.label }} <span class="text-muted">#{{ r.id }}</span></td>
          <td>{{ r.from_email }}</td>
          <td>{{ reason(r.verdict) }}</td>
          <td>{{ r.is_default ? 'Yes' : 'No' }}</td>
          <td>{{ r.is_active ? 'Yes' : 'No' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/**
 * SenderDomainCheck - the operator's list of sender identities that fail the
 * From-domain rule (send safety slice 4), on the Usage and plans page. Reads
 * GET /api/v1/admin/sending/sender-domains (Ops::PLATFORM).
 */
import useApi from "@apexl/icarus-core/src/services/api";

export default {
  name: 'SenderDomainCheck',
  data() {
    return {
      api: useApi(),
      loading: true,
      error: '',
      rows: [],
      operatorTenant: 1,
      rule: { warn_requested: false, warn_active: false },
    };
  },
  mounted() { this.load(); },
  methods: {
    async load() {
      this.loading = true; this.error = '';
      try {
        const res = await this.api.get('/api/v1/admin/sending/sender-domains');
        const body = res?.data ?? res;
        this.rows = Array.isArray(body?.data) ? body.data : [];
        this.operatorTenant = body?.operator_tenant ?? 1;
        this.rule = body?.rule || this.rule;
      } catch (e) {
        this.error = e?.response?.data?.error || e?.message || 'Could not load the sender list.';
      }
      this.loading = false;
    },
    reason(verdict) {
      return {
        own_unverified: 'Its domain is added but not verified',
        other_workspace: 'Its domain belongs to another workspace, or is the platform domain',
        untracked: 'Its domain is not added under Sending domains',
        invalid: 'The address has no domain',
      }[verdict] || verdict;
    },
  },
};
</script>

<style>
.sdc { background: var(--m-bg-card, #FFF); border: 1px solid var(--m-border, #E2E8F0); border-radius: 8px; padding: 16px; }
.sdc-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; }
.sdc-title { font-weight: 600; margin-bottom: 4px; }
.sdc-note { color: var(--m-text-secondary, #475569); font-size: 0.85rem; max-width: 760px; }
.sdc-warn { color: var(--m-status-danger, #991B1B); font-size: 0.85rem; }
.sdc-table { font-size: 0.85rem; margin-top: 8px; }
</style>
